import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UiMultiSelectComponent} from '@ui/modules/ui-multi-select/ui-multi-select.component';

@NgModule({
  declarations: [
    UiMultiSelectComponent
  ],
  exports: [
    UiMultiSelectComponent
  ],
  imports: [
    CommonModule
  ]
})
export class UiMultiSelectModule {
}
